<template>
    <button
        :class="['quiz-choice', {'selected': isSelected }, {'selected-answer-correct': isSelectedAnswerCorrect }, {'selected-answer-incorrect': isSelectedAnswerIncorrect }]"
        type="button"
        @click="selectAnswer"
    >
        <span class="quiz-choice__label">{{ label }}</span>
        <span class="quiz-choice__text" v-html="answer.choice"></span>
        <span class="icon-cross" v-if="isAnswerSubmitted && isSelectedAnswerIncorrect"></span>
        <span class="icon-checkmark" v-if="isAnswerSubmitted && correctChoice"></span>
    </button>
</template>

<script>
    export default {
        name: 'quiz-choice',
        props: {
            answer: {
                type: Object,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            isSelected: {
                type: Boolean,
                required: true
            },
            isSelectedAnswerCorrect: {
                type: Boolean
            },
            isSelectedAnswerIncorrect: {
                type: Boolean
            },
            isAnswerSubmitted: {
                type: Boolean
            },
            correctChoice: {
                type: Boolean,
                default: null
            }
        },
        methods: {
            selectAnswer () {
                this.$emit('select-answer')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-choice {
        border-radius: 500px;
        border: 1px solid rgba(0, 0, 0, 0.20);
        display: flex;
        background: $white;
        padding: 0;
        cursor: pointer;
        margin: 0 0 20px;
        position: relative;

        &:hover {
            border: 2px solid $lavender;
        }

        &:last-of-type {
            margin: 0;
        }

        &__label {
            font-family: PlusJakartaSans-Bold, sans-serif;
            font-size: 2rem;
            color: $tuatara;
            background: $concrete;
            padding: 8px 20px;
            border-radius: 500px 0 0 500px;
            display: flex;
            align-items: center;
        }

        &__text {
            font-family: PlusJakartaSans-Regular, sans-serif;
            font-size: 1.6rem;
            text-align: left;
            color: $black;
            padding: 10px 40px 10px 20px;
        }

        &.selected {
            border: 2px solid $lavender;

            .quiz-choice__label {
                color: $white;
                background: $lavender;
            }

            .quiz-choice__text {
                padding: 9px 20px;
            }
        }

        &.selected-answer-correct {
            border: 2px solid $william;

            .quiz-choice__label {
                background: $william;
            }
        }

        &.selected-answer-incorrect {
            border: 2px solid $chestnut;

            .quiz-choice__label {
                background: $chestnut;
            }
        }

        [class*="icon-"] {
            position: absolute;
            right: 20px;
            top: 10px;
        }

        .icon-checkmark {
            color: $william;
            font-size: 1.8rem;
        }

        .icon-cross {
            color: $valencia;
        }
    }
</style>
